<template>
    <div :class="keyboardClass" />
</template>

<script>
import Keyboard from 'simple-keyboard';

export default {
    name: 'SimpleKeyboard',
    props: {
        keyboardClass: {
            default: 'simple-keyboard',
            type: String,
        },
        input: {
            type: String,
        },
        hasNumpad: Boolean,
        // keeps focus where it is, e.g. in Stripe's card iframe
        preventMouseDown: Boolean,
    },
    data() {
        return {
            keyboard: null,

            layoutEN: {
                default: [
                    '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
                    '{tab} q w e r t y u i o p [ ] \\',
                    "{lock} a s d f g h j k l ; ' {enter}",
                    '{shift} z x c v b n m , . / {shift}',
                    '.com @ {space}',
                ],
                shift: [
                    '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
                    '{tab} Q W E R T Y U I O P { } |',
                    '{lock} A S D F G H J K L : " {enter}',
                    '{shift} Z X C V B N M < > ? {shift}',
                    '.com @ {space}',
                ],
            },

            layoutFR: {
                default: [
                    '` 1 2 3 4 5 6 7 8 9 0 \u00B0 + {bksp}',
                    '{tab} a z e r t y u i o p ^ $',
                    '{lock} q s d f g h j k l m \u00F9 * {enter}',
                    '{shift} < w x c v b n , ; : ! {shift}',
                    '.fr @ {space}',
                ],
                shift: [
                    '\u00B2 & \u00E9 " \' ( - \u00E8 _ \u00E7 \u00E0 ) = {bksp}',
                    '{tab} A Z E R T Y U I O P \u00A8 \u00A3',
                    '{lock} Q S D F G H J K L M % \u00B5 {enter}',
                    '{shift} > W X C V B N ? . / \u00A7 {shift}',
                    '.fr @ {space}',
                ],
            },

            layoutTW: {
                default: [
                    '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
                    '{tab} \u30C6 \u30CA \u30CF \u30CB \u30F3 \u30CE \u30D5 \u30A2 \u30A8 \u30B3 \u309D \u30E0',
                    "{lock} \u30C1 \u30B7 \u30C1\u3099 \u30AF\u3099 \u30B1\u3099 \u30F3 \u30AB \u30A1 \u30A3 \u30A5 ; ' {enter}",
                    '{shift} \u30C3 \u30C4 \u30B5 \u30BD \u30D2 \u30AD \u30AF \u30B3 \u30B5\u3099 \u30C8\u3099 {shift}',
                    '.tw @ {space}',
                ],
                shift: [
                    '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
                    '{tab} \u30C6\u3099 \u30CA\u3099 \u30CF\u3099 \u30CB\u3099 \u30F3\u3099 \u30CE\u3099 \u30D5\u3099 \u30A4 \u30A8\u3099 \u30B3\u3099 \u309E \u30E0\u3099',
                    '{lock} \u30C1\u3099 \u30B7\u3099 \u30C6\u3099 \u30AF\u3099 \u30B1\u3099 \u30F3\u3099 \u30AB\u3099 \u30A2 \u30A4 \u30A6 : " {enter}',
                    '{shift} \u30C3\u3099 \u30C4\u3099 \u30B5\u3099 \u30BD\u3099 \u30D2\u3099 \u30AD\u3099 \u30AF\u3099 \u30B3\u3099 \u30B5\u3099 \u30C8\u3099 {shift}',
                    '.tw @ {space}',
                ],
            },

            layoutDE: {
                default: [
                    '^ 1 2 3 4 5 6 7 8 9 0 \u00DF \u00B4 {bksp}',
                    '{tab} q w e r t z u i o p \u00FC +',
                    '{lock} a s d f g h j k l \u00F6 \u00E4 # {enter}',
                    '{shift} < y x c v b n m , . - {shift}',
                    '.de @ {space}',
                ],
                shift: [
                    '\u00B0 ! " \u00A7 $ % & / ( ) = ? ` {bksp}',
                    '{tab} Q W E R T Z U I O P \u00DC *',
                    "{lock} A S D F G H J K L \u00D6 \u00C4 ' {enter}",
                    '{shift} > Y X C V B N M ; : _ {shift}',
                    '.de @ {space}',
                ],
            },

            layoutAT: {
                default: [
                    '^ 1 2 3 4 5 6 7 8 9 0 \u00DF \u00B4 {bksp}',
                    '{tab} q w e r t z u i o p \u00FC +',
                    '{lock} a s d f g h j k l \u00F6 \u00E4 # {enter}',
                    '{shift} < y x c v b n m , . - {shift}',
                    '.at @ {space}',
                ],
                shift: [
                    '\u00B0 ! " \u00A7 $ % & / ( ) = ? ` {bksp}',
                    '{tab} Q W E R T Z U I O P \u00DC *',
                    "{lock} A S D F G H J K L \u00D6 \u00C4 ' {enter}",
                    '{shift} > Y X C V B N M ; : _ {shift}',
                    '.at @ {space}',
                ],
            },

            layoutCH: {
                default: [
                    '^ 1 2 3 4 5 6 7 8 9 0 \u00DF \u00B4 {bksp}',
                    '{tab} q w e r t z u i o p \u00FC +',
                    '{lock} a s d f g h j k l \u00F6 \u00E4 # {enter}',
                    '{shift} < y x c v b n m , . - {shift}',
                    '.ch @ {space}',
                ],
                shift: [
                    '\u00B0 ! " \u00A7 $ % & / ( ) = ? ` {bksp}',
                    '{tab} Q W E R T Z U I O P \u00DC *',
                    "{lock} A S D F G H J K L \u00D6 \u00C4 ' {enter}",
                    '{shift} > Y X C V B N M ; : _ {shift}',
                    '.ch @ {space}',
                ],
            },

            layoutLI: {
                default: [
                    '^ 1 2 3 4 5 6 7 8 9 0 \u00DF \u00B4 {bksp}',
                    '{tab} q w e r t z u i o p \u00FC +',
                    '{lock} a s d f g h j k l \u00F6 \u00E4 # {enter}',
                    '{shift} < y x c v b n m , . - {shift}',
                    '.li @ {space}',
                ],
                shift: [
                    '\u00B0 ! " \u00A7 $ % & / ( ) = ? ` {bksp}',
                    '{tab} Q W E R T Z U I O P \u00DC *',
                    "{lock} A S D F G H J K L \u00D6 \u00C4 ' {enter}",
                    '{shift} > Y X C V B N M ; : _ {shift}',
                    '.li @ {space}',
                ],
            },

            layoutNL: {
                default: [
                    '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
                    '{tab} q w e r t y u i o p [ ] \\',
                    "{lock} a s d f g h j k l ; ' {enter}",
                    '{shift} z x c v b n m , . / {shift}',
                    '.nl @ {space}',
                ],
                shift: [
                    '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
                    '{tab} Q W E R T Y U I O P { } |',
                    '{lock} A S D F G H J K L : " {enter}',
                    '{shift} Z X C V B N M < > ? {shift}',
                    '.nl @ {space}',
                ],
            },

            layoutFI: {
                default: [
                    '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
                    '{tab} q w e r t y u i o p [ ] \\',
                    "{lock} a s d f g h j k l ; ' {enter}",
                    '{shift} z x c v b n m , . / {shift}',
                    '.fi @ {space}',
                ],
                shift: [
                    '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
                    '{tab} Q W E R T Y U I O P { } |',
                    '{lock} A S D F G H J K L : " {enter}',
                    '{shift} Z X C V B N M < > ? {shift}',
                    '.fi @ {space}',
                ],
            },

            layoutIT: {
                default: [
                    '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
                    '{tab} q w e r t y u i o p [ ] \\',
                    "{lock} a s d f g h j k l ; ' {enter}",
                    '{shift} z x c v b n m , . / {shift}',
                    '.it @ {space}',
                ],
                shift: [
                    '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
                    '{tab} Q W E R T Y U I O P { } |',
                    '{lock} A S D F G H J K L : " {enter}',
                    '{shift} Z X C V B N M < > ? {shift}',
                    '.it @ {space}',
                ],
            },

            layoutNumpad: {
                default: [
                    '{numpad7} {numpad8} {numpad9}',
                    '{numpad4} {numpad5} {numpad6}',
                    '{numpad1} {numpad2} {numpad3}',
                    '{numpad0} {bksp} {enter}',
                ],
            },
        };
    },
    mounted() {
        if (!this.keyboard) {
            let determinedLayout = this.getLayoutByLang();

            if (this.hasNumpad) {
                determinedLayout = this.layoutNumpad;
            }

            // its own element: by class it picked the first match, which is
            // the old keyboard while that one still slides out
            this.keyboard = new Keyboard(this.$el, {
                onChange: this.onChange,
                onKeyPress: this.onKeyPress,
                layout: determinedLayout,
                preventMouseDownDefault: this.preventMouseDown,
                display: {
                    '{enter}': '↩',
                    '{tab}': '↹',
                    '{lock}': '⇪',
                    '{shift}': '⇧',
                    '{bksp}': '⌫',
                    '{space}': ' ',

                    '{numpad9}': '9',
                    '{numpad8}': '8',
                    '{numpad7}': '7',
                    '{numpad6}': '6',
                    '{numpad5}': '5',
                    '{numpad4}': '4',
                    '{numpad3}': '3',
                    '{numpad2}': '2',
                    '{numpad1}': '1',
                    '{numpad0}': '0',
                },
            });
        }
    },
    methods: {
        getLayoutByLang() {
            const lang = this.$i18n.locale;

            if (lang === 'de') {
                return this.layoutDE;
            }

            if (lang === 'ch') {
                return this.layoutCH;
            }

            if (lang === 'at') {
                return this.layoutAT;
            }

            if (lang === 'li') {
                return this.layoutLI;
            }

            if (lang === 'nl') {
                return this.layoutNL;
            }

            if (lang === 'fi') {
                return this.layoutFI;
            }

            if (lang === 'tw') {
                return this.layoutTW;
            }

            if (lang === 'en') {
                return this.layoutEN;
            }

            if (lang === 'it') {
                return this.layoutIT;
            }

            if (lang === 'fr') {
                return this.layoutFR;
            }

            return this.layoutEN;
        },
        onChange(input) {
            this.$emit('onChange', input);
        },
        onKeyPress(button) {
            this.$emit('onKeyPress', button);

            if (button === '{enter}') {
                this.$emit('onEnter');
            }

            if (button === '{shift}' || button === '{lock}') this.handleShift();
        },
        handleShift() {
            let currentLayout = this.keyboard.options.layoutName;
            let shiftToggle = currentLayout === 'default' ? 'shift' : 'default';

            this.keyboard.setOptions({
                layoutName: shiftToggle,
            });
        },
    },
    watch: {
        input(input) {
            this.keyboard.setInput(input);
        },
    },
};
</script>

<style scoped></style>
